import PromoBg from "assets/png/promo_man_alt_1.png";
import styled from "styled-components";

import { TitleBase } from "uikit/Typography/styles";

import { Container as BaseContainer, HeaderContainerRow } from "../styles";

const containerHeight = 640;
const promoBgImageHeight = 487;
const containerInnerWidth = 400;

export const Container = styled(BaseContainer)`
  height: ${containerHeight}px;
  background-image: url("${PromoBg}");
  background-size: auto ${promoBgImageHeight}px;
`;

export const HeaderContainer = styled(HeaderContainerRow)`
  ${TitleBase} {
    width: ${containerInnerWidth}px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: ${containerInnerWidth}px;
`;
